import React, { useState } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import classNames from "classnames";
import styles from "./ButtonDropdown.scss";

export interface ButtonDropdownItem {
  label: string;
  value: () => void;
}

export interface ButtonDropdownProps {
  /**
   * Button name
   */
  label: string | JSX.Element;
  /**
   * Button contents
   */
  items: ButtonDropdownItem[];
  /**
   * Additional class names
   */
  className?: string;

  /**
   * control disabled
   */
  disabled?: boolean;
}

/**
 * Primary UI component for user interaction
 */
export const ButtonDropdownProvider: React.FC<ButtonDropdownProps> = (
  props
) => {
  const [dropdownOpen, setOpen] = useState(false);

  const toggle = () => {
    setOpen(!dropdownOpen);
  };

  return (
    <ButtonDropdown
      isOpen={dropdownOpen}
      toggle={toggle}
      disabled={props.disabled}
      className={`${classNames(props.disabled ? styles["disabled"]: "", props.className)} `}
    >
      <DropdownToggle
        className={classNames(styles["au-btn-dropdown"])}
        style={{ padding: "8px 24px", zIndex: 0 }}
        caret
      >
        {props.label}
      </DropdownToggle>
      {props.items && (
        <DropdownMenu
          className={classNames(styles["au-dropdownmenu"])}
        >
          {props.items.map((x, i) => {
            return (
              <DropdownItem
                key={i}
                onClick={x.value}
                className={classNames(
                  styles["au-dropdownitem"],
                  props.className
                )}
              >
                {x.label}
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      )}
    </ButtonDropdown>
  );
};
